import { render, staticRenderFns } from "./DialogConsentCheckUserOnechat.vue?vue&type=template&id=10694822&scoped=true&"
import script from "./DialogConsentCheckUserOnechat.vue?vue&type=script&lang=js&"
export * from "./DialogConsentCheckUserOnechat.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentCheckUserOnechat.vue?vue&type=style&index=0&id=10694822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10694822",
  null
  
)

export default component.exports